import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { applyPromoCode } from '../store/cartSlice';
import { calculateSubtotal } from '../utils/priceHandler';
import { fnUrl } from "../config/endpoints";

export const usePromoCode = ( promoCode, setPromoCode ) => {
  const submittedPromoCodes = useSelector(state => state.cart.submittedPromoCodes);
  const [promoError, setPromoError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const cartItems = useSelector((state) => state.cart.cartItems);
  const dispatch = useDispatch();

  const handleApplyPromoCode = async (customCode) => {
    const rawCode = customCode || promoCode;
    const codeToApply = String(rawCode || '').trim().toUpperCase();
    
    if (!codeToApply) return;
    
    if (submittedPromoCodes.some(p => p.code.toUpperCase() === codeToApply)) {
      return;
    }
    
    setIsSubmitting(true);
    setPromoError('');
    
    try {
      const subtotal = calculateSubtotal(cartItems);
      const res = await fetch(fnUrl("validate-promo-code"), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code: codeToApply, cart_total: subtotal })
      });
      
      const data = await res.json();
      
      if (!res.ok || !data.valid) {
        setPromoError(data.message || 'Invalid promo code.');
        return;
      }
      
      if (submittedPromoCodes.some(p => p.code.toLowerCase() === codeToApply.toLowerCase())) {
        setPromoError('Promo code already applied.');
        return;
      }
      
      const promoData = {
        code: codeToApply,
        free_shipping: data.free_shipping,
        max_order_total: data.max_order_total,
        is_affiliate: data.is_affiliate,
        discount_type: data.discount_type,
        discount_amount: data.discount_amount
      };
      
      dispatch(applyPromoCode(promoData));
      
    } catch (error) {
      setPromoError('Something went wrong while applying the promo code.');
    } finally {
      setIsSubmitting(false);
      setPromoCode?.('');
    }
  };

  return {
    handleApplyPromoCode,
    promoError,
    isSubmitting
  };
};